import { Pipe, PipeTransform } from '@angular/core';
import { Processo } from '../../modelos/processo';

@Pipe({
  name: 'filtroProcessos'
})
export class FiltroProcessosPipe implements PipeTransform {

  transform(processos: Processo[], filtro?: string): any {
    if (processos === undefined || filtro === undefined || filtro.trim() === '') {
      return processos;
    }
    filtro = filtro.toLocaleLowerCase();
    return processos.filter(processo => processo.nomeProcesso.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-processos.pipe.ts